//mock data for userDetails
export const userInitials = "GS";

//header image
export const headerImage = `${process.env.PUBLIC_URL}/images/Pearson-logo-desktop.svg`;
